var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: { title: "Xuất file excel", visible: _vm.visible, width: "700px" },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "label-width": "80px",
            size: "normal",
            "label-position": "top",
          },
        },
        [
          _c("el-alert", {
            attrs: {
              title: "Lưu ý",
              type: "info",
              description:
                " Hệ thống chỉ xuất được tối đa 5000 kết quả. Vui lòng nhập trang và số kết quả bạn\n      muốn xuất excel",
              "show-icon": "",
            },
          }),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 12, offset: 0 } }),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 12, offset: 0 } }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "Trang", prop: "page" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.form.page,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "page", $$v)
                  },
                  expression: "form.page",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: "Bạn muốn xuất bao nhiêu bản ghi",
                prop: "limit",
              },
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.form.limit,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "limit", $$v)
                  },
                  expression: "form.limit",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("Đóng")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleExport } },
            [_vm._v("Xuất excel")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }